import React from 'react'

import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import styled from 'styled-components'

export const PageNotFound: React.FC = () => {
  return (
    <PageNotFoundContainer>
      <Text variant='s24' mb={3}>
        PAGINA NON TROVATA!
      </Text>
    </PageNotFoundContainer>
  )
}

const PageNotFoundContainer = styled(Container)`
  text-align: center;
`
